<template>
  <div class="hello navMargin">
    <NavBar :transparent-on-top="true" active="lectorem"></NavBar>
    <Carousel v-if="slides.length>0" :slides="slides"></Carousel>

    <br>
    <div class="noMeLaContainer">
      <!-- <vs-input border icon-after primary type="search" v-model="value3" label-placeholder="Buscar..." style="margin-left: 25%; margin-right: 25%;">
        <template #icon>
          <i class='bx bx-search-alt'></i>
        </template>
      </vs-input> -->
      <h1 class="centrar">
        Categorías
      </h1>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" lg="2" sm="4" class="colMargin" v-for="categoria in categoriesAvailable" :key="categoria.id">
          <vs-card type="1" style="width: 90%;" class="centrarButton">
            <template #title><b></b></template>
            <template #text>
              <p class="centrar">
                <b>{{categoria.nombreCorto}}</b>
              </p>
            </template>
          </vs-card>
        </vs-col>
      </vs-row>
      <h1 class="centrar">
        Recomendados
      </h1>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" lg="2" sm="4" class="colMargin" v-for="serie in featuredSeries" :key="serie.id">
          <vs-card type="2" @click="openShowInfo(1, serie.nombre, serie.url)" class="landingCard">
            <template #title>
              <b>{{ serie.nombre }}</b>
            </template>
            <template #img>
              <!-- <img src="https://img1.ak.crunchyroll.com/i/spire1/5601eec39026ea5dbf88fc35d9d6fb9f1516836642_full.jpg" alt=""> -->
              <img :src="serie.poster_vertical" alt="">
            </template>
            <template #text>
              <p>

              </p>
            </template>
            <!-- <template #interactions>
              <vs-button class="btn-chat" shadow danger>
                <i class='bx bx-heart' ></i>
                <span class="span">54</span>
              </vs-button>
            </template> -->
          </vs-card>
        </vs-col>
      </vs-row>
      <h1 class="centrar">
        Más gustados
      </h1>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" lg="2" sm="4" class="colMargin" v-for="serie in featuredSeries" :key="serie.id">
          <vs-card type="2" @click="openShowInfo(1, serie.nombre, serie.url)" class="landingCard">
            <template #title>
              <b>{{ serie.nombre }}</b>
            </template>
            <template #img>
              <!-- <img src="https://img1.ak.crunchyroll.com/i/spire1/5601eec39026ea5dbf88fc35d9d6fb9f1516836642_full.jpg" alt=""> -->
              <img :src="serie.poster_vertical" alt="">
            </template>
            <template #text>
              <p>

              </p>
            </template>
            <!-- <template #interactions>
              <vs-button class="btn-chat" shadow danger>
                <i class='bx bx-heart' ></i>
                <span class="span">54</span>
              </vs-button>
            </template> -->
          </vs-card>
        </vs-col>
      </vs-row>
    </div>
    <vs-dialog scroll overflow-hidden full-screen v-model="activeMoreInfo">
      <template #header>
        <h1 class="not-margin">
          <b>{{ dialog.title }} <span class="badge tip top" v-if="dialog.typeSerie !== ''">{{ dialog.typeSerie }}</span></b>
        </h1>
      </template>
      <vs-row style="padding-left: 4%; padding-right: 4%">
        <vs-col w="2">
          <div class="hideWhenSmall"><img :src="dialog.image" width="100%"/></div> <div class="showWhenSmall"><img :src="dialog.imagev" width="100%"/></div>

          <div class="showWhenSmall">
            <vs-button danger block size="large" class="centrarButton" :href="dialog.serieLink">
              <i class='bx bx-list-ul'></i> Capítulos
            </vs-button>
          </div>
        </vs-col>
        <!-- <vs-col w="1"></vs-col> -->
        <vs-col w="6" style="margin-left: 3%">
          <!-- Fecha -->
          <b>Fecha de publicación</b> <br>
          <span class="sangria">{{ $luxonDateTime.fromISO(dialog.published).toLocaleString($luxonDateTime.DATE_MED) }} <br></span>

          <!-- Publisher -->
          <b>Editor</b>
          <div style="display: flex; align-items: center; justify-content: left; flex-wrap: wrap;" v-if="dialog.publishers.length === 1" class="sangria">
            <vs-avatar size="35" style="margin-right: 1%">
              <i class='bx bx-user'></i>
            </vs-avatar>
            {{ dialog.publishers[0].nombre }}
          </div>
          <br v-if="dialog.publishers.length === 1">
          {{ dialog.description }}
        </vs-col>
        <vs-col w="3">
          <div class="stars">
            <span class="stars-badge"><i class="bx bxs-star"></i> 4.8</span>
            <span class="stars-rate" style="float: right">
              <span class="star-not-rated star"><i class="bx bxs-star"></i></span>
              <span class="star-not-rated star"><i class="bx bxs-star"></i></span>
              <span class="star-not-rated star"><i class="bx bxs-star"></i></span>
              <span class="star-not-rated star"><i class="bx bxs-star"></i></span>
              <span class="star-not-rated star"><i class="bx bxs-star"></i></span>
            </span>
          </div>
          {{ dialog.tags }}
          <vs-button danger block size="large" class="noventa centrarButton" :href="dialog.serieLink">
            <i class='bx bx-list-ul'></i>‎‎‎‎ Capítulos
          </vs-button>
          <ul class="centrar">
            <li>
              <vs-tooltip bottom>
                <vs-button icon color="danger" border>
                  <i class='bx bxs-heart bx-lg' ></i>
                </vs-button>
                <template #tooltip>
                  Me gusta
                </template>
              </vs-tooltip>
            </li>
            <li>
              <vs-tooltip bottom>
                <vs-button icon color="primary" border>
                  <i class='bx bxs-bookmark bx-lg' ></i>
                </vs-button>
                <template #tooltip>
                  Añadir a Mi Lista
                </template>
              </vs-tooltip>
            </li>
            <li>
              <vs-tooltip right>
                <vs-button icon color="rgb(255, 130, 0)">
                  <i class='bx bxs-share-alt bx-lg' ></i>
                </vs-button>
                <template #tooltip>
                  Compartir
                </template>
              </vs-tooltip>
            </li>
          </ul>
        </vs-col>
      </vs-row>
      <!-- <div class="centrar">
        <img :src="dialog.image" width="30%"/>
      </div> -->

      <!-- <template #footer>
        <div class="footer-dialog hideWhenSmall">
          <vs-row justify="center">
            <vs-col w="6">
              <vs-button danger block size="large" class="noventa centrarButton" :href="dialog.serieLink">
                <i class='bx bx-list-ul'></i> Capítulos
              </vs-button>
            </vs-col>
          </vs-row>
        </div>
      </template> -->
    </vs-dialog>
  </div>
</template>

<script>
import axios from "axios";
import NavBar from "../components/NavBar";
import Carousel from "../components/Carousel";

export default {
  name: "LandingPageBooks",
  components: {Carousel, NavBar},
  data() {
    return {
      slides: [],
      slideIndex: 1,
      currPage: 1,
      activeMoreInfo: false,
      dialog: {
        title: "",
        description: "Cargando...",
        image: "",
        imagev: "",
        serieLink: "",
        publishers: [],
        typeSerie: "",
        published: "",
        capitulos: {}
      },
      slidesAnime: {},
      value3: "",
      featuredSeries: {},
      categoriesAvailable: {},
      interval: null
    }
  },
  methods: {
    showSlides(n) {
      clearInterval(this.interval);
      this.slideIndex = n;
      var i;
      var slides = document.getElementsByClassName("mySlides");
      var dots = document.getElementsByClassName("dot");
      if (n > slides.length) {
        this.slideIndex = 1
      }
      if (n < 1) {
        this.slideIndex = slides.length
      }
      for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
      }
      slides[this.slideIndex - 1].style.display = "block";
      dots[this.slideIndex - 1].className += " active";
      this.slideInterval();
    },
    nextSlide() {
      this.slideIndex = this.slideIndex + 1;
      var i;
      var slides = document.getElementsByClassName("mySlides");
      var dots = document.getElementsByClassName("dot");
      if (this.slideIndex > slides.length) {
        this.slideIndex = 1
      }
      if (this.slideIndex < 1) {
        this.slideIndex = slides.length
      }
      for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
      }
      slides[this.slideIndex - 1].style.display = "block";
      dots[this.slideIndex - 1].className += " active";
    },
    slideInterval () {
      this.interval = setInterval(() => {
        this.slideIndex = this.slideIndex + 1;
        var i;
        var slides = document.getElementsByClassName("mySlides");
        var dots = document.getElementsByClassName("dot");
        if (this.slideIndex > slides.length) {
          this.slideIndex = 1
        }
        if (this.slideIndex < 1) {
          this.slideIndex = slides.length
        }
        for (i = 0; i < slides.length; i++) {
          slides[i].style.display = "none";
        }
        for (i = 0; i < dots.length; i++) {
          dots[i].className = dots[i].className.replace(" active", "");
        }
        slides[this.slideIndex - 1].style.display = "block";
        dots[this.slideIndex - 1].className += " active";
      }, 10000)
    },
    async openShowInfo(id, title, url) {
      this.activeMoreInfo = true;
      this.dialog.title = title;
      const loading = this.$vs.loading({
        background: '#000',
        color: '#fff',
        text: 'Cargando...'
      });
      await axios.get('https://api.videnti.co/lectorem/' + url)
          .then(response => {
            if (!response.data[0]) {
              window.location = '../?error=SERIE_NO_EXISTE';
            }
            this.title = response.data[0].nombre;
            this.dialog.description = response.data[0].descripcion;
            this.dialog.image = response.data[0].poster_vertical; // poster_horizontal
            this.dialog.imagev = response.data[0].poster_vertical;
            this.dialog.published = response.data[0].published;
            // this.dialog.firstEpisodeLink = window.location.origin + "/lectorem/" + url + "/1/1";
            this.dialog.serieLink = window.location.origin + "/lectorem/" + url + "/";
            this.dialog.typeSerie = response.data[0].nombreCategoria;
            switch (response.data[0].status) {
              case 0:
                this.status = "Publicándose"
                break;
              case 1:
                this.status = "Finalizado";
                break;
              case 2:
                this.status = "Hiatus";
                break;
              default:
                this.status = "Otro";
                break;
            }
            /* this.poster = response.data[0].poster_vertical;
            this.idSerie = response.data[0].idSerie; */
            this.dialog.idLibro = response.data[0].idLibro;
          }).catch(error => console.log(error));
      await axios
          .get('https://api.videnti.co/publishersByBookUrl/' + url)
          .then(resPublishers => {
            this.dialog.publishers = resPublishers.data;
          });
      await axios
          .get('https://api.videnti.co/lectoremCapitulos/' + id)
          .then(resTemp => {
            this.dialog.capitulos = resTemp.data;
            this.dialog.capitulos.forEach((obj, index) => {
              // console.log('Searching for UUIDs for chapter: ' + obj.number + " v3.");
              axios.get('https://api.videnti.co/lectoremUUIDsByIdCapitulo/' + obj.idLibroCapitulo)
                  .then(resUUID => this.dialog.capitulos[index].links = resUUID.data);
            });
          });
      loading.close();
      console.log(id);
    }
  },
  async created() {
    const loading = this.$vs.loading({
      background: '#000',
      color: '#fff',
      text: 'Cargando...'
    });

    await axios
        .get('https://api.videnti.co/carousel/getItems/')
        .then(res => {
          // this.slidesAnime = resTemp.data;
          this.slides = res.data;
        }).catch(error => {
          this.$vs.notification({
            progress: 'auto',
            color: "danger",
            title: 'Ocurrió un pequeño error',
            text: `No se ha podido cargar el carrusel. Lamentamos los inconvenientes.`
          });
          console.log(error);
        });

    await axios
        .get('https://api.videnti.co/featuredBooks')
        .then(resFeatured => {
          this.featuredSeries = resFeatured.data;
        })

    /* var slides = document.getElementsByClassName("mySlides");
    var dots = document.getElementsByClassName("dot");
    slides[0].style.display = "block";
    dots[0].className += " active"; */
    loading.close();
    // this.slideInterval();
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  metaInfo() {
    return {
      title: 'Lectorem - Manga, Cómics y Libros online',
      htmlAttrs: {
        lang: 'es'
      },
      meta: [
        { charset: 'utf-8' },
        { name: 'description', content: 'Lee y descubre historias interesantes en nuestro catálogo de manga, cómics, novelas y libros de forma gratuita con Lectorem.' }
      ]
    }
  }
}
</script>

<style scoped>
div#fondo {
  background-color: rgba(0, 0, 0, 0.686);
  background-image: url(../assets/bg_inicio.png);
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  background-blend-mode: overlay;
  z-index: -2;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.slideshow-container {
  /* background-color: black; */
  /* max-width: 1000px; */
  position: relative;
  margin: auto;
}

/* Hide the images by default */
.mySlides {
  display: none;
}

/* Next & previous buttons */
.prev, .next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  margin-top: -22px;
  padding: 16px;
  color: white;
  font-weight: bold;
  font-size: 18px;
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  user-select: none;
}

/* Position the "next button" to the right */
.next {
  right: 0;
  border-radius: 3px 0 0 3px;
}

/* On hover, add a black background color with a little bit see-through */
.prev:hover, .next:hover {
  background-color: rgba(0,0,0,0.8);
}

/* Caption text */
.text {
  color: #f2f2f2;
  font-size: 15px;
  /* padding: 8px 12px; */
  position: absolute;
  bottom: 0px;
  width: 100%;
  text-align: center;
}

.text h3 {
  margin-bottom: 0;
}

/* Number text (1/3 etc) */
.numbertext {
  color: #f2f2f2;
  font-size: 12px;
  padding: 8px 12px;
  position: absolute;
  top: 0;
}

/* The dots/bullets/indicators */
.dot {
  cursor: pointer;
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}

.active, .dot:hover {
  background-color: #717171;
}

/* Fading animation */
.fade {
  -webkit-animation-name: fade;
  -webkit-animation-duration: 1.5s;
  animation-name: fade;
  animation-duration: 1.5s;
}

@-webkit-keyframes fade {
  from {opacity: .4}
  to {opacity: 1}
}

@keyframes fade {
  from {opacity: .4}
  to {opacity: 1}
}

.centrarButton {
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

.stars {
  font-size: 1.7em;
}

.stars-badge {
  display: inline-block;
  /* font-size: 1.7rem; */
  border-radius: 5px;
  padding: 1px 5px;
  color: #f5b615;
  margin-right: 0;
  background-color: #585858;
  cursor: default;
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.stars-rate {
  display: inline-block;
  border-radius: 5px;
  padding: 1px 5px;
  color: #f5b615;
  margin-right: 0;
  background-color: #585858;
  /* cursor: default; */
}

.star-rated {
  color: #f5b615;
  cursor: none;
}

.star-not-rated {
  color: #313131;
  cursor: pointer;
}

.star-not-rated:hover {
  color: #f5b615;
}

.stars .star {
  float:right;
  color: #aaa;
  text-decoration: none;
  -webkit-transition: color .4s;
  -moz-transition: color .4s;
  -o-transition: color .4s;
  transition: color .4s;
}

.stars-rate {
  direction: rtl;
}

.stars-rate .star:hover ~ .star,
.stars-rate .star:focus ~ .star,
.stars-rate .star:hover,
.stars-rate .star:hover,
.stars-rate .star:hover ~ .star,
.stars-rate .star:focus,
.stars-rate .star:focus ~ .star {
  color: #f5b615;
  cursor: pointer;
}

.stars-rate .star {
  float: none;
}

.sangria {
  padding-left: 10px;
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>

<style>
.chapters > div > table {
  min-width: initial !important;
}
</style>
